import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'

function collectText(model: any, out: string[] = []): string[] {
  if (model.text) {
    out.push(model.text.toString());
  }
  if (model.children) {
    for (const child of model.children) {
      collectText(child, out);
    }
  }
  return out;
}

function getDocumentPlainText(editor: any): string {
  const store = editor.host.doc;
  const root = store.root;
  if (!root) return '';
  return collectText(root).join('\n');
}

// 字数统计（包含标点，不包含空格）
function countCharsWithoutSpaces(text: string): number {
  return text.replace(/\s/g, '').length;
}

export function useWordCount(editor: any) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!editor) return;

    const store = editor.host.doc;

    const updateCount = () => {
      const text = getDocumentPlainText(editor);
      const _count = countCharsWithoutSpaces(text)
      const parts = window.location.pathname?.split("/").filter(Boolean)
      localStorage.setItem('currentDoc', JSON.stringify({
        workspaceId: parts[1],
        docId: parts[2],
      }));
      localStorage.setItem('currentDoc.count', _count)
      setCount(_count);
    };

    // 初始加载时，确保文档 ready
    if (store.root) {
      updateCount();
    } else {
      const off = store.slots.docUpdated.on(() => {
        if (store.root) {
          updateCount();
          off.dispose(); // 只跑一次
        }
      });
    }

    // 后续每次编辑（事务完成时）更新
    const sub = store.slots.historyUpdated.on(() => {
      updateCount();
    });

    return () => {
      sub.dispose();
    };
  }, [editor]);

  return count;
}
